import { useEffect } from 'react';

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNext();
      if (e.key === 'ArrowLeft') onPrev();
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, onNext, onPrev]);

  const img = images[currentIndex];
  if (!img) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.95)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'fadeIn 0.2s ease',
      }}
    >
      {/* Immagine */}
      <img
        src={img.src}
        alt={img.caption}
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: '90vw', maxHeight: '85vh',
          objectFit: 'contain', display: 'block',
          boxShadow: '0 0 80px rgba(0,0,0,0.8)',
        }}
      />

      {/* Caption */}
      {img.caption && (
        <div style={{
          position: 'absolute', bottom: '32px', left: '50%', transform: 'translateX(-50%)',
          fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700,
          letterSpacing: '0.1em', textTransform: 'uppercase',
          color: 'var(--white)', background: 'rgba(0,0,0,0.5)',
          padding: '8px 16px', pointerEvents: 'none',
        }}>{img.caption}</div>
      )}

      {/* Chiudi */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute', top: '24px', right: '32px',
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--white)', fontSize: '32px', opacity: 0.7,
          lineHeight: 1, transition: 'opacity 0.2s',
        }}
        onMouseEnter={e => e.target.style.opacity = 1}
        onMouseLeave={e => e.target.style.opacity = 0.7}
      >✕</button>

      {/* Prev */}
      {images.length > 1 && (
        <button
          onClick={e => { e.stopPropagation(); onPrev(); }}
          style={{
            position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--white)', fontSize: '48px', opacity: 0.5,
            transition: 'opacity 0.2s', padding: '12px',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = 1}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.5}
        >‹</button>
      )}

      {/* Next */}
      {images.length > 1 && (
        <button
          onClick={e => { e.stopPropagation(); onNext(); }}
          style={{
            position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--white)', fontSize: '48px', opacity: 0.5,
            transition: 'opacity 0.2s', padding: '12px',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = 1}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.5}
        >›</button>
      )}

      {/* Contatore */}
      <div style={{
        position: 'absolute', top: '28px', left: '50%', transform: 'translateX(-50%)',
        fontFamily: 'var(--font-title)', fontSize: '11px', letterSpacing: '0.2em',
        color: 'rgba(255,255,255,0.4)',
      }}>{currentIndex + 1} / {images.length}</div>

      <style>{`@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }`}</style>
    </div>
  );
}
